/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from 'react';
import { css } from 'styled-components';
import uniqueId from '../../../../helpers/uniqueId';
import Button from '@vfuk/core-button';

const externalLinkWrapperStyles = css`
  padding: 10px 0;
  max-width: 40%;
`;

type ExternalLinkProps = {
  label: string;
  href: string;
};

// Add data-analytics-context to the articles ctaExternalLink buttons
const CtaExternalLink = ({ label, href }: ExternalLinkProps) => {
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    setTimeout(() => {
      const elem = document.getElementsByTagName('TITLE')[0];
      setPageTitle(elem.innerHTML);

      const ctaExternalLinks = Array.from(
        document.querySelectorAll('#ctaExternalLink')
      );
      if (ctaExternalLinks.length !== 0) {
        ctaExternalLinks.forEach(ctaExtLink => {
          ctaExtLink.setAttribute('data-analytics-context', pageTitle);
        });
      }
    }, 500);
  }, [pageTitle]);

  const onClickHandler = () => {
    window.open(href, '_blank');
  };

  return (
    <div css={externalLinkWrapperStyles}>
      <Button
        id="ctaExternalLink"
        text={label}
        appearance="primary"
        onClick={onClickHandler}
        title={label}
        data-analytics-element={uniqueId(label)}
        data-analytics-category="cta-external-link"
      />
    </div>
  );
};

export default CtaExternalLink;
